import React from 'react'
import ContactForm from "../components/ContactForm";

class Contact extends React.Component {

  external(e) {
    e.preventDefault();
    window.open(e.currentTarget.href);
  }

  render() {
    return (
    	<React.Fragment>
    		<section className="bg--black row align-items-center no-gutters">

    			<div className="col-md-12 contact">
      				<h1>Bonjour !</h1>
      				<p>Talents, briefs, projets… Nous sommes à votre écoute ! </p>
    			</div>
    		</section>
        <section className="bg--black">
          <div className="map__container">
            <img className="map" src={ process.env.PUBLIC_URL + "/images/map.jpg" } alt="" />
            <div className="bg--black map__address">
              <span className="map__address__title">
                <img src={ process.env.PUBLIC_URL + "/images/logos/cosmic.png" } alt="Cosmic" />
              </span>
              <span>
                2 Place du Colonel Fabien<br/>
                75019 Paris
              </span>
              <span className="map__address__contacts">
                bonjour@agencecosmic.com<br/>
                talents@agencecosmic.com<br/>
                +33 (0)1 44 58 58 58
              </span>
            </div>
            <ContactForm />
          </div>
        </section>
        <section className="bg--black linkedin">
          <h2>Retrouvez-nous sur
            <a onClick={this.external } href="https://www.linkedin.com/company/cosmic-communication/">
              <img src={ process.env.PUBLIC_URL + "/images/logos/soc-linkedin.png" } alt="Linkedin" />
            </a>
          </h2>
        </section>
    	</React.Fragment>
  	)
  }
}

export default Contact




// WEBPACK FOOTER //
// ./src/containers/Contact.jsx